var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 316 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 390,
    rx: 5,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 234.21V223.44C34.27 209.28 47.34 174.3 62.08 134.84C76.45 96.34 91.32 56.53 127.98 30.35C149.13 15.24 171.97 10.01 194.29 10C225.21 10 255.14 20.05 278.22 27.79C293.66 32.98 308.35 37.9 316 37.06V47.06C306.12 47.71 292.45 43.12 275.03 37.28C234.97 23.83 180.09 5.41 133.79 38.48C99.62 62.89 85.3 101.25 71.44 138.34C55.91 179.94 41.11 219.56 0 234.21Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.481 293.26C139.121 278.42 160.011 264.55 180.221 251.14C232.301 216.57 277.281 186.71 307.971 158.09C310.801 155.46 313.471 152.85 316.001 150.28V164.36C284.731 193.77 238.911 224.18 185.751 259.47C165.581 272.86 144.721 286.71 123.131 301.51C88.9707 324.94 72.3507 350.15 73.7507 376.45C74.0007 381.15 74.8107 385.76 76.0807 390.28H65.7507C64.6907 385.95 64.0107 381.52 63.7707 377.01C62.1607 346.98 80.2307 318.8 117.481 293.26Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternThree);
export default __webpack_public_path__ + "static/media/PatternThree.b5a37f6a2a892743cb352f29170b34de.svg";
export { ForwardRef as ReactComponent };